import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import * as d3 from 'd3-dsv';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { Menu, Dropdown, Icon, Button, Input, Spin, Table, 
        Modal, Tag, Pagination, Drawer, Timeline } from 'antd';

import {setNewFenceMapCenter,
        serverLoadOrganization,
        serverLoadOrganizationPois,
        serverImportAddresses,
        serverRemoveOrganization,
        serverRemovePOIs} from '../actions';

import {getMapCenter} from '../../shared/helpers/fence';

const PAGE_SIZE = 25;

const loadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

const confirm = Modal.confirm;

const linkStyles = {
  marginLeft: '0.8em',
}

const addressStyles = {
  padding: '0.8em 0em',
  margin: 0,
  boxSizing: 'border-box',
};

const buttonStyles = {
  marginRight: '0.4em',
};

const timelineStyles = {
  padding: '1.6em 0em',
  boxSizing: 'border-box',
};

const validationStages = [
  {
    key: 'validOrganization',
    label: 'Valid Organization'
  },
  {
    key: 'fixPOICenter', 
    label: 'Fix POI Center',
  },
  {
    key: 'fixOnPremise',
    label: 'Fix On-Premise',
  }
];

const defaultOrganizationSidebarState = {
  poiSearchTerm: '',
  pageNumber: 0,
  addressDialogOpen: false,
  addPOIDialogOpen: false,
  organizationDeleteConfirmationOpen: false,
  poiDeleteConfirmationOpen: false,
  addressesText: '',
  deletePOIIds: [],

  drawerOpen: false,
  selectedPOI: null,
}

class OrganizationSidebar extends Component {
  constructor(props){
    super(props);

    this.state = defaultOrganizationSidebarState;

    const self = this;

    this.columns = [{
        title: 'Name',
        key: 'name',
        render: (record) => (
          <div>
            <div style={{ flexGrow: 1}}>
              <a href="" onClick={(e) => {
                e.preventDefault();
                self.setMapCenter(record.poi.location);
              }}>{record.poi.name}</a>
              <a 
                style={{ marginLeft: 8 }}
                onClick={() => {
                  self.openPOIInfoDrawer(record);
                }}
              >
                <Icon type="info-circle" />
              </a>
            </div>
            <div style={{ flexGrow: 1}}>
              <Tag>{record.poi.validation.fixPOICenter.completed ? 'Active' : 'Pending'}</Tag>
              <Tag>{!record.poi.unsure ? 'Verified' : 'Unsure'}</Tag>
            </div>
            <div style={{ flexGrow: 1}}>
              <p style={addressStyles}>{record.poi.formattedAddress}</p>
            </div>
            <div style={{ flexGrow: 1}}>
              <Link 
                target="__blank__"
                to={`/validation/fixOnPremise/${record.poi._id}`}>Fix On-Premise</Link>
              <Link 
                target="__blank__"
                to={`/validation/fixPOICenter/${record.poi._id}`} 
                style={linkStyles}
              >Fix POI Centre</Link>
            </div>
          </div>
        ),
    },{
      title: '#Fences',
      key: 'fenceCount',
      width: 100,
      render: (record) => (
        <span>{record.fences.length}</span>
      )
    }];

    this.onTableChange = this.onTableChange.bind(this);
    this.openPOIInfoDrawer = this.openPOIInfoDrawer.bind(this);
    this.closePOIInfoDrawer = this.closePOIInfoDrawer.bind(this);
  }
  resetState(){
    this.setState(defaultOrganizationSidebarState);
  }

  componentDidMount() {
    let organizationId = this.props.match.params.organization_id;
    this.props.getOrganization(organizationId);
    this.props.getOrganizationPois(organizationId, '');
  }

  onAddressesTextChange(event, newValue){
    this.setState({
      addressesText: newValue,
    });
  }

  toggleAddressDialog(){
    this.setState({
      addressDialogOpen: !this.state.addressDialogOpen,
      addressesText: '',
    });
  }

  toggleOrganizationDeleteConfirmation(){
    this.setState({
      organizationDeleteConfirmationOpen: !this.state.organizationDeleteConfirmationOpen,
    });
  }

  togglePOIDeleteConfirmation(){
    this.setState({
      poiDeleteConfirmationOpen: !this.state.poiDeleteConfirmationOpen,
    });
  }

  togglePOIAddDialog(){
    this.setState({
      addPOIDialogOpen: !this.state.addPOIDialogOpen,
    });
  }

  clearSelected(){
    this.setState({
      deletePOIIds: [],
    });
  }

  onTableChange(page){
    const organizationId = this.props.match.params.organization_id;

    this.setState({
      pageNumber: page - 1,
    }, () => {
      this.props.getOrganizationPois(organizationId, '', this.state.pageNumber);
    });
  }

  onSearchTextChange(e){
    this.setState({
      poiSearchTerm: e.target.value,
      pageNumber: 0,
    });

    // Search for organization POI
    let organizationId = this.props.match.params.organization_id;
    this.props.getOrganizationPois(organizationId, e.target.value);
  }

  onAddAddresses(){
    let organizationId = this.props.match.params.organization_id;
    const addresses = [];

    const csvList = d3.csvParse(this.state.addressesText);

    for (let i = 0; i < csvList.length; i += 1) {
      addresses.push({
        name: csvList[i].name,
        address: csvList[i].full_address,
      })
    }
    if (_.isFunction(this.props.importAddresses)) this.props.importAddresses(organizationId, addresses);
    this.toggleAddressDialog();
  }

  onDeleteOrganization(){
    let organizationId = this.props.match.params.organization_id;
    this.props.removeOrganization(organizationId);
    this.toggleOrganizationDeleteConfirmation();
  }

  onDeletePOIs(){
    let organizationId = this.props.match.params.organization_id;
    this.togglePOIDeleteConfirmation();
    this.props.removePOIs(this.state.deletePOIIds, organizationId);
    this.resetState();
  }

  setMapCenter(fenceGeo){
    this.props.selectNewFenceMapCenter(getMapCenter(fenceGeo));
  }

  openPOIInfoDrawer(poi){
    this.setState({
      drawerOpen: true,
      selectedPOI: poi,
    })
  }

  closePOIInfoDrawer() {
    this.setState({
      drawerOpen: false,
    });
  }

  render() {
    const { state } = this;

    const organizationId = this.props.match.params.organization_id;

    let organizationInfo = this.props.organizationsMap.get(organizationId);
    let organizationPois = this.props.paginatedOrganizationPOIMap.getIn([organizationId, this.state.pageNumber]);

    if (_.isUndefined(organizationInfo)){
      return (
        <div style={{ marginTop: '40%', textAlign: 'center' }}>
          <Spin indicator={loadingIcon} />
        </div>
      )
    }

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        let deletePOIIds = selectedRows.map((row) => row.poi._id);
        this.setState({
          deletePOIIds,
        });
      },
      selectedRowKeys: this.state.deletePOIIds,
    };
    
    const deletePOIsSegment = () => (
      <div className="segment">
        <div>
            <b>{this.state.deletePOIIds.length} POIs selected</b>
            <div style={{ marginTop: 5 }}>
              <Button
                type="danger"
                style={{ marginRight: 5 }}
                onClick={() => {
                  const self = this;
                  confirm({
                    title: 'Are you sure you want to delete the selected POIs?',
                    okText: 'Yes',
                    okType: 'danger',
                    cancelText: 'No',
                    onOk() {
                      self.onDeletePOIs();
                    },
                    onCancel() {
                    },
                  });
                }}>
                Delete
              </Button>
              <Button
                type="default"
                onClick={(e) => {
                  this.clearSelected();
                  e.preventDefault();
                }}>
                Clear
              </Button>
            </div>
        </div>
      </div>
    )

    const dropdownMenu = (
      <Menu>
        <Menu.Item key="1" onClick={() => {
            this.props.history.push(`/organizations/${organizationInfo._id}/upload`);
        }}><Icon type="upload" />Import POIs</Menu.Item>

        <Menu.Item key="2" onClick={() => {
            this.props.history.push(`/organizations/${organizationInfo._id}/create-poi`);
        }}><Icon type="new" />Create POI</Menu.Item>
        <Menu.Item key="3" onClick={() => {
          const self = this;
          confirm({
            title: 'Are you sure you want to delete this organization?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
              self.onDeleteOrganization();
            },
            onCancel() {
            },
          });
        }}><Icon type="delete" />Delete Organization</Menu.Item>
      </Menu>
    );

    const validationStageTimeline = (validationSummary) => {
      return (
        <Timeline>
          {validationStages.map((stage, i) => {
            return validationSummary[stage.key].completed ? (
              <Timeline.Item key={i}>
                {`${stage.label} validation done by `}
                {validationSummary[stage.key].completedByUser ? (
                  `${validationSummary[stage.key].completedByUser.firstName}
                    ${validationSummary[stage.key].completedByUser.lastName}`
                ): 'User Unknown'}
                {` at ${moment(validationSummary[stage.key].completedAt).toString()}`}
              </Timeline.Item>
            ): (
              <Timeline.Item key={i}>
                {`${stage.label} validation not complete`}
              </Timeline.Item>
            )
          })}
        </Timeline>
      )
    }

    const drawer = () => {
      const poi = state.selectedPOI;
      return (poi === null) ? null : (
        <Drawer
            width={720}
            placement="right"
            onClose={this.closePOIInfoDrawer}
            maskClosable={false}
            visible={state.drawerOpen}
            style={{
              height: 'calc(100% - 55px)',
              overflow: 'auto',
              paddingBottom: 53,
            }}
          >
          <div>
            <h5>{`${poi.poi.category}   >  ${poi.poi.subcategory}`}</h5>
            <h4>{poi.poi.name}</h4>
            <p>{poi.poi.formattedAddress}</p>
            <div style={{ padding: '0.5em 0em', boxSizing: 'border-box' }}>
              <Tag>{poi.poi.source}</Tag>
            </div>
            <div>
              <Button style={buttonStyles} type="primary">
                <Link 
                  target="__blank__"
                  to={`/validation/validOrganization/${poi.poi._id}`}>Fix Valid Organization</Link>
              </Button>
              <Button style={buttonStyles} type="primary">
                <Link 
                  target="__blank__"
                  to={`/validation/fixPOICenter/${poi.poi._id}`}>Fix POI Center</Link>
              </Button>
              <Button style={buttonStyles} type="primary">
                <Link 
                  target="__blank__"
                  to={`/validation/fixOnPremise/${poi.poi._id}`}>Fix On-Premise</Link>
              </Button>
            </div>
            <div style={{ marginTop: 20 }}>
              {poi.poi.markedUnsureByUser ? 
                (<p>
                  <b>Marked Unsure By : </b>
                  {poi.poi.markedUnsureByUser.firstName} {poi.poi.markedUnsureByUser.lastName}
                </p>)
                : null}
            </div>
            <div style={timelineStyles}>
              {validationStageTimeline(poi.poi.validation)}
            </div>
          </div>
        </Drawer>
      );
    };

    return (
      <div>
        <div className="sidebar-info">
          <div className="sidebar-inner">
            {!_.isNull(organizationInfo) ? (
              <div>
                <div style={{ position: 'relative' }}>
                  <h5>{`${organizationInfo.category}   >  ${organizationInfo.subcategory}`}</h5>
                  <h4 className="heading-level-1">
                    {organizationInfo.name}
                  </h4>
                  <div style={{ padding: "0px 0px 10px 0px"}}>
                    <b className="inline-subheading">
                      {organizationInfo.livePOICount} / {organizationInfo.poiCount} POIs Live
                    </b>
                  </div>
                  <Dropdown overlay={dropdownMenu} placement="bottomRight">
                    <a style={{ right: 0, top: 0, position: 'absolute', fontSize: 24 }}>
                      <Icon type="ellipsis" />
                    </a>
                  </Dropdown>
                </div>
                <div style={{ padding: "10px 0px 0px 0px" }}>
                  <Input placeholder='Search...' onChange={this.onSearchTextChange.bind(this)} />
                </div>
                {this.state.deletePOIIds.length > 0 ? deletePOIsSegment(): null}
              </div>
            ): null}
          </div>
        </div>
        <div className="sidebar-inner">  
          {drawer()}
        <div>
          {!_.isUndefined(organizationPois) ? (
            <Table
                columns={this.columns}
                dataSource={organizationPois}
                rowKey={(record) => record.poi._id}
                rowSelection={rowSelection}
                pagination={false}
            />
          ) : (
            <div style={{ margin: '20% 0', textAlign: 'center' }}>
              <Spin indicator={loadingIcon} />
            </div>
          )}
          <div style={{ padding: '2rem 1rem', boxSizing: 'border-box' }}>
            <Pagination 
                current={state.pageNumber + 1} 
                total={state.poiSearchTerm.length > 0 ? organizationPois.length : organizationInfo.poiCount}
                onChange={this.onTableChange}
                pageSize={PAGE_SIZE}
          /> 
          </div>
        </div>
        </div>
      </div>
    );
  }
}

OrganizationSidebar.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      'organization_id': PropTypes.string,
    })
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  getOrganization: PropTypes.func,
  getOrganizationPois: PropTypes.func,
  importAddresses: PropTypes.func,
  removeOrganization: PropTypes.func,
  removePOIs: PropTypes.func,
  selectNewFenceMapCenter: PropTypes.func,
  organizationPoiMap: PropTypes.instanceOf(Immutable.Map),
  paginatedOrganizationPOIMap: PropTypes.instanceOf(Immutable.Map),
  organizationsMap: PropTypes.instanceOf(Immutable.Map),
}

// Map props to the store

const mapStateToProps = (state) => {
  return {
    organizationsMap: state.routes.organizations.server.getIn(['organizationsMap']),
    organizationPoiMap: state.routes.organizationPois.get('organizationPoiMap'),
    paginatedOrganizationPOIMap: state.routes.organizationPois.get('paginatedPOIs')
  }
};

const mapDispatchToProps = (dispatch) => ({
  getOrganizationPois: (organizationId, searchTerm, page)=>{
    dispatch(serverLoadOrganizationPois(organizationId, searchTerm, page));
  },
  getOrganization: (organizationId) => {
    dispatch(serverLoadOrganization(organizationId));
  },
  selectNewFenceMapCenter: (location)=>{
    dispatch(setNewFenceMapCenter(location));
  },
  importAddresses: (organizationId, addresses) => {
    dispatch(serverImportAddresses(organizationId, addresses));
  },
  removeOrganization: (organizationId) => {
    dispatch(serverRemoveOrganization(organizationId));
  },
  removePOIs: (poiIds, organizationId) => {
    dispatch(serverRemovePOIs(poiIds, organizationId));
  }
})

const OrganizationSidebarContainer = connect(mapStateToProps,mapDispatchToProps)(OrganizationSidebar);

export default OrganizationSidebarContainer;


// WEBPACK FOOTER //
// ./src/organizations/components/OrganizationSidebar.js